"use client";

import { createContext, useContext } from "react";
export const ExtractionAnnotationPopoverContext = createContext<(() => void) | undefined>(undefined);
export function useExtractionAnnotationPopover() {
  return useContext(ExtractionAnnotationPopoverContext);
}